import axios from "axios";

// export const validateToken = async (token) => {
//   if (!token) throw new Error("No token");

//   return axios.get(
//     `${process.env.REACT_APP_TRADEPLUS_URL}/api/Auth/`,
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
// };

export const validateToken = async (token) => {
  if (!token) throw new Error("No token");

  return axios.get(
    `${process.env.REACT_APP_TRADEPLUS_URL}/api/Auth`,
    {
      params: { accessToken: token },
    }
  );
};